import Grid from '@mui/material/Grid';
import MouthCompositionText from './MouthCompositionText';
import MicroButtonGroup from './CompoAux/MicroButtonGroup';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import GetCompo from './Profiling/GetCompo';
//import GetHealthPara from './HealthIndicators/GetHealthPara';


export default function MouthSectionComposition() {

    
    return (

     <SectionStructure
        
        sectiontext=    { <MouthCompositionText /> }
        sectiondiagroup=    { <MicroButtonGroup />} 

        sectioncards=  {
        
            <Grid container spacing={0}>
                    <Grid size={{xs:12, xl:12}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start'}}> <GetCompo />  </Grid>
                     <Grid size={{xs:12, xl:6}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start'}}>   </Grid>
                </Grid>        
        }

    />

    )
}